import React from 'react'
import { Translation } from 'react-i18next'
/**
 * Welcome Page
 *
 * @author Pragya Gupta
 */

const WelcomePage = () => (
  <Translation>
    {(t) => {
      return (
        <div className="container-fluid cover">
          <div className="col-xs-12 col-sm-12 col-lg-12">
            <p
              style={{
                color: '#F67131',
                fontWeight: 'bold',
                textAlign: 'center'
              }}
            >
              {t('employer.welcome.p')}
            </p>
          </div>
        </div>
      )
    }}
  </Translation>
)

export default WelcomePage
